import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import styles from './FourPart.module.less';
import SoftCardFourPart from '../../components/SoftCardFourPart/SoftCardFourPart';
import {
  sortSoftsByLocalSoftInit,
  addClass,
  removeClass,
  loggingADX,
  logNative,
  getUrlByTargetContent,
  getSoftType,
} from '../../utils/utils';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import { setIframeVisible } from '../../actions/layout';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showData, setShowData] = useState({});
  const [showSofts, setShowSofts] = useState([]);
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);
  const LOG_ACTION_SOURCE = {
    c_change: `${logInfo.clTag || logInfo.tag}_Group_ChangePage`,
    c_action: `${logInfo.clTag || logInfo.tag}_Group_More`,
    c_action_adx: `${logInfo.clTag || logInfo.tag}_Group_More_ADX`,
    source: `${logInfo.tag}_Group`,
  };

  const swiperEl = useRef(null);
  const swiperNext = useRef(null);
  const swiperPrev = useRef(null);
  const swiperParams = {
    speed: 600,
    slidesPerView: 'auto',
    slidesPerGroup: 4,
    spaceBetween: 14,
    allowTouchMove: false,
  };

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (
      data &&
      data.dataList &&
      data.dataList.length > 0 &&
      data.dataList[0] &&
      data.dataList[0].apps
    ) {
      const showSoftArr = sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit);
      if (showSoftArr.length > 3) {
        setShowSofts(showSoftArr);
      }
      setShowData(data.dataList[0]);
    }
  }, [dispatch, localSoftsInit, data]);

  const handleShowNextPrev = useCallback(
    flag => {
      if (swiperEl && swiperEl.current && swiperEl.current.swiper) {
        const swiperObj = swiperEl.current.swiper;
        if (flag === 'next') {
          swiperObj.slideNext();
        }
        if (flag === 'prev') {
          swiperObj.slidePrev();
        }
        if (swiperPrev && swiperPrev.current && swiperNext && swiperNext.current) {
          swiperObj.isEnd
            ? addClass(swiperNext.current, styles.swiper_soft_hidden)
            : removeClass(swiperNext.current, styles.swiper_soft_hidden);
          swiperObj.isBeginning
            ? addClass(swiperPrev.current, styles.swiper_soft_hidden)
            : removeClass(swiperPrev.current, styles.swiper_soft_hidden);
        }

        dispatch(
          logging({
            category: 'C',
            action: LOG_ACTION_SOURCE.c_change,
            label: '',
            param2: {
              source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              title: data.title,
              pageCardContentId: showData.pageCardContentId,
              nextOrPrev: flag,
              pageNum: swiperObj.snapIndex + 1,
            },
          }),
        );
      }
    },
    [logInfoData, swiperEl, swiperNext, swiperPrev, showData],
  );

  const loggingADXClick = useCallback(bannerADX => {
    // 推荐页面ADX banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_action_adx,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    if (bannerADX && bannerADX.impTracks) {
      const clickTracks = JSON.parse(bannerADX.clickTracks);
      loggingADX(clickTracks);
    }
  }, []);

  const handleShowMore = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_action,
          label: '',
          param2: {
            source: LOG_ACTION_SOURCE.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      if (
        bannerInfo.targetType === '1' ||
        bannerInfo.targetType === '3' ||
        bannerInfo.targetType === '11'
      ) {
        dispatch(
          logPostInfo({
            source_p: LOG_ACTION_SOURCE.source,
            source_pp: logInfoData.source_p,
          }),
        );
        let url = `${CONTEXT}/`;
        if (bannerInfo.targetType && bannerInfo.targetContent) {
          url = getUrlByTargetContent(bannerInfo);
        }
        history.push(url);
      } else if (bannerInfo.targetType === '2') {
        if (bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetContent) {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        }
      } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
        let targetContent = {};
        try {
          targetContent = JSON.parse(bannerInfo.targetContent);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
        if (targetContent && targetContent.url) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: targetContent.url,
              source: LOG_ACTION_SOURCE.source,
            }),
          );
        }
      } else if (bannerInfo.targetType === '10' && bannerInfo.advertCrid && bannerInfo.advertUrl) {
        loggingADXClick(bannerInfo);
        window.open(bannerInfo.advertUrl);
      } else {
        history.push(`${CONTEXT}/error`);
      }
    },
    [dispatch, logInfoData, history],
  );

  return showSofts && showSofts.length > 0 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div className={styles.card} ref={refDom}>
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
              {data.operate && data.operate === '2' && (
                <div className={styles.card_header_more} onClick={() => handleShowMore()}>
                  更多
                </div>
              )}
            </div>
            <div className={styles.card_softs}>
              <Swiper {...swiperParams} ref={swiperEl}>
                {showSofts.map((item, j) => (
                  <div key={j} className={styles.swiper_soft}>
                    <SoftCardFourPart
                      soft={{ ...item, hoverShow: data.hoverShow }}
                      logInfo={{
                        ...logInfo,
                        ///////////////////////////
                        softid: item?.androidType === '1' ? item?.packageName : item?.softID,
                        softType: getSoftType(item),
                        contentType: 'soft',
                        rankCode: showData.code,
                        org: showData.org || '',
                        cardType: data.cardType,
                        cardName: data.cardType,
                        pageCardTitle: data.title,
                        pageCardId: showData.pageCardContentId,
                        ///////////////////////////
                        source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
                        source_p: logInfoData.source_p,
                        source_pp: logInfoData.source_pp,
                      }}
                      key={j}
                    />
                  </div>
                ))}
              </Swiper>
              <div
                className={`${styles.swiper_soft_prev} ${styles.swiper_soft_hidden}`}
                onClick={() => {
                  handleShowNextPrev('prev');
                }}
                ref={swiperPrev}
              />
              {showSofts.length > 4 && (
                <div
                  className={styles.swiper_soft_next}
                  onClick={() => {
                    handleShowNextPrev('next');
                  }}
                  ref={swiperNext}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
